<template>
  <div class="bg-white p-4 rounded-md">
    <p class="font-bold text-xl pb-2 tracking-tight text-gray-900">
      {{ t("product_informations") }}
    </p>

    <div v-if="allowVirtualProduct" class="mb-4">
      <div class="flex gap-4">
        <label class="flex items-center gap-2 cursor-pointer">
          <input
            type="radio"
            name="productNature"
            value="physical"
            :checked="selectedNature === 'physical'"
            class="text-primary focus:ring-primary"
            @change="handleNatureChange('physical')"
          />
          <span class="text-sm text-gray-700">{{ t("connected_device") }}</span>
        </label>
        <label class="flex items-center gap-2 cursor-pointer">
          <input
            type="radio"
            name="productNature"
            value="virtual"
            :checked="selectedNature === 'virtual'"
            class="text-primary focus:ring-primary"
            @change="handleNatureChange('virtual')"
          />
          <span class="text-sm text-gray-700">{{ t("internet_tv_offer") }}</span>
        </label>
      </div>
    </div>

    <VirtualProductForm
      v-if="isVirtual"
      :modelValue="modelValue"
      @update:modelValue="$emit('update:modelValue', $event)"
      @continue="$emit('continue')"
    />
    <PhysicalProductForm
      v-else
      :modelValue="modelValue"
      @update:modelValue="$emit('update:modelValue', $event)"
      @continue="$emit('continue')"
    />
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";
import PhysicalProductForm from "@/components/pos/subscription/formwithsteps/PhysicalProductForm.vue";
import VirtualProductForm from "@/components/pos/subscription/formwithsteps/VirtualProductForm.vue";

export default {
  components: {
    PhysicalProductForm,
    VirtualProductForm,
  },
  props: {
    modelValue: Object,
    allowVirtualProduct: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue", "continue"],
  setup() {
    const { t } = useI18n();
    return { t };
  },
  data() {
    return {
      selectedNature: this.modelValue?.productNature || "physical",
    };
  },
  watch: {
    "modelValue.productNature"(newNature) {
      this.selectedNature = newNature || "physical";
    },
  },
  computed: {
    isVirtual() {
      return this.selectedNature === "virtual";
    },
  },
  methods: {
    handleNatureChange(nature) {
      this.selectedNature = nature;

      if (nature === "virtual") {
        this.$emit("update:modelValue", {
          ...this.modelValue,
          title: "",
          price: null,
          productNature: "virtual",
          referenceId: "",
          lineHolderName: "",
          transactionDate: "",
        });
      } else {
        this.$emit("update:modelValue", {
          ...this.modelValue,
          title: "",
          price: "",
          productNature: null,
          referenceId: "",
          lineHolderName: "",
          transactionDate: "",
        });
      }
    },
  },
};
</script>

<i18n src="./ProductForm.i18n.json"></i18n>
